//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import manba from 'manba'
import { EventBus } from '../../../../../EventBus/EventBus.js'
import { axiosPost } from '../../../../../axios/axios.js'

import MedicalTestForm from '../../../../../forms/Medical/MedicalPageForm.vue'
import MedicalPageWarning from './MedicalPageWarning.vue'

export default {
  components: {
    MedicalTestForm,
    MedicalPageWarning
  },
  props: {
    height: {
      type: Number,
      default: 400
    }
  },
  data: function () {
    return {
      medicalSchedule: [],
      pagination: {
        rowsPerPage: 0
      },
      columns: [
        {
          name: 'medicalExaminationResult',
          label: 'Итог',
          align: 'left',
          field: 'medicalExaminationResult',
          sortable: true
        },
        {
          name: 'medicalExaminationKind',
          label: 'Смена',
          align: 'center',
          field: 'medicalExaminationKind',
          sortable: true
        },
        {
          name: 'inspectionTime',
          label: 'Время',
          align: 'left',
          field: 'inspectionTime',
          sortable: true
        },
        {
          name: 'employeeFIO',
          label: 'Сотрудник',
          align: 'left',
          field: 'employeeFIO',
          sortable: true
        },
        {
          name: 'medicalExaminationOrigin',
          label: 'Список',
          align: 'left',
          field: 'medicalExaminationOrigin',
          sortable: true
        }
      ],
      colorBtnStartFinish: 'primary',
      startBtn: true,
      labelBtnStartFinish: 'СТАРТ',
      showMedicalShedule: false,
      timeoutStartId: 0,
      subHeightContent: 132,
      timeoutActiveMedicineId: 0,
      isActiveBtn: false,
      isMedicEmployee: false,
      showBannerMedic: false,
      isTransportAdmin: false,
      listWorkShiftMedical: null,
      messageActualTranslate: '',
      warningTranslate: [],
      confirmFinish: false,
      isMedicalTablo: false
    }
  },
  watch: {
    isActiveBtn: {
      handler: function (state) {
        if (!state) {
          clearTimeout(this.timeoutStartId)
          this.timeoutStartId = null
          this.medicalSchedule = []
        } else {
          if (!this.timeoutStartIdtartId) {
            this.startMedical()
          }
        }
      },
      immediate: true
    },
    showMedicalShedule: {
      handler: function (show) {
        EventBus.$emit('set-show-medical-shedule', { show: show, page: 'medicine' })
      },
      immediate: true
    }
  },
  beforeDestroy: function () {
    clearTimeout(this.timeoutStartId)
    this.timeoutStartId = null
    clearTimeout(this.timeoutActiveMedicineId)
    this.timeoutActiveMedicineId = null

    this.showMedicalShedule = false
    EventBus.$emit('get-medical-shedule', false)
  },
  created: function () {
    const user = this.$store.getters.getUser
    this.isMedicEmployee = this.$d_hasRole('medical')
    this.isTransportAdmin = this.$d_hasRole('transportAdmin')
    this.subHeightContent = this.isMedicEmployee || this.isTransportAdmin ? 94 : 132
    if (!user.isMedicalTablo) {
      this.getActiveMedicine()
    } else {
      this.isMedicalTablo = true
    }
  },
  methods: {
    getActiveMedicine: function () {
      const that = this
      if (!this.isTransportAdmin) {
        setTimeout(function getActive () {
          that.regularMedicalScheduleStatus()
          that.timeoutActiveMedicineId = setTimeout(getActive, 120000)
        }, 0)
      } else {
        that.showMedicalShedule = true
        setTimeout(function getListTransport () {
          EventBus.$emit('get-medical-shedule', that.showMedicalShedule)
          that.timeoutStartId = setTimeout(getListTransport, 120000)
        }, 0)
      }
    },
    startMedical: function () {
      const that = this
      setTimeout(function getList () {
        if (that.isActiveBtn) {
          EventBus.$emit('get-medical-shedule', that.showMedicalShedule)
        }
        that.timeoutStartId = setTimeout(getList, 300000)
      }, 0)
    },
    onRunMedicalTest: function (row = null) {
      if (this.$refs.modalMedicalTestForm && !this.$refs.modalMedicalTestForm.formOpen) {
        this.$refs.modalMedicalTestForm.groupUnSuccess = null
        this.$refs.modalMedicalTestForm.id = row ? row.employeeId : null
        this.$refs.modalMedicalTestForm.recordId = row ? row.id : null
        this.$refs.modalMedicalTestForm.onOpen()
      }
    },
    getExaminationOriginIcon: function (origin = null) {
      let iconName = ''
      switch (origin) {
        case 'random':
          iconName = 'mdi-shuffle-variant'
          break
        case 'required':
          iconName = 'mdi-all-inclusive'
          break
        case 'manual':
          iconName = 'mdi-gesture-tap'
          break
        default:
          iconName = ''
          break
      }
      return iconName
    },
    getTime: function (time) {
      return manba(time).format('HH:mm')
    },
    getShiftName: function (kind, examTime) {
      const now = new Date(manba(examTime).format('YYYY-MM-DD hh:mm'))
      const borderTime = new Date(manba(examTime).format('YYYY-MM-DD 12:00'))
      if (kind == 'preTrip' && now.getTime() < borderTime.getTime()) {
        return 'День'
      } else if (kind == 'postTrip' && now.getTime() < borderTime.getTime()) {
        return 'Ночь'
      } else if (kind == 'preTrip' && now.getTime() >= borderTime.getTime()) {
        return 'Ночь'
      } else if (kind == 'postTrip' && now.getTime() >= borderTime.getTime()) {
        return 'День'
      } else {
        return ''
      }
    },
    setStateBtn: function (state) {
      this.$nextTick(() => {
        this.startBtn = !state
        this.colorBtnStartFinish = this.startBtn ? 'primary' : 'negative'
        this.labelBtnStartFinish = this.startBtn ? 'СТАРТ' : 'ФИНИШ'
        this.showMedicalShedule = !this.startBtn
      })
    },
    onStartFinish: function () {
      this.confirmFinish = false
      this.$nextTick(() => {
        this.regularMedicalSchedule(this.startBtn)
        this.setStateBtn(this.startBtn)
      })
    },
    updateData: function (record) {
      const now = new Date()
      this.$nextTick(() => {
        if (this.$refs.modalMedicalTestForm) {
          this.$refs.modalMedicalTestForm.formOpen = false
        }
        EventBus.$emit('update-result-medical-test', {
          id: record.id,
          result: record.result,
          inspectionTime: now.getTime()
        })
      })
    },
    onActionFinish: function (action) {
      if (action) {
        // confirmFinish = true
        this.regularMedicalSchedule(false, false, true)
        this.setStateBtn(false)
        clearTimeout(this.timeoutStartId)
        this.timeoutStartId = null
        this.medicalSchedule = []
      } else {
        this.$nextTick(() => {
          this.startBtn = false
          this.colorBtnStartFinish = 'negative'
          this.labelBtnStartFinish = 'ФИНИШ'
          this.showMedicalShedule = true
        })
      }
    },
    regularMedicalSchedule: function (action, prolongation = false, confirmFinish = false) {
      const urlName = '/service/delta/journal/regularMedicalSchedule/startStopMedical'
      const bodyFormData = new FormData()
      bodyFormData.set('start', action)
      if (prolongation) {
        bodyFormData.set('prolongation', true)
      }
      if (confirmFinish) {
        bodyFormData.set('confirmFinish', true)
      }
      return axiosPost({
        url: urlName,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          let messageTxt = action ? 'Начало медосмотра' : 'Завершение медосмотра'
          if (prolongation) {
            messageTxt = 'Продолжение медосмотра'
            this.showBannerMedic = false
          }
          if (this.showMedicalShedule) {
            this.startMedical()
          }
          this.$q.notify({
            type: 'positive',
            message: messageTxt,
            progress: true,
            timeout: 3000
          })
          return Promise.resolve()
        },
        onFailure: (response) => {
          const message = prolongation ? '/продолжения' : ''
          if (response.details && response.details === 'confirm finish required') {
            this.$refs.modalMedicalWarning.employees =
                this.medicalSchedule.filter(item => !item.medicalExaminationResult).map(item => item.employeeFIO)
            this.$refs.modalMedicalWarning.onOpen()
          } else {
            this.$q.notify({
              type: 'negative',
              message: response.message ? response.message : ('Ошибка старта/финиша' + message + ' (Exception)'),
              progress: true,
              timeout: 10000
            })
          }
          return Promise.reject(response.message ? response.message : 'Exception')
        }
      })
    },
    regularMedicalScheduleStatus: function () {
      const urlName = '/service/delta/journal/regularMedicalSchedule/getDayMedicalExamStatus'
      return axiosPost({
        url: urlName,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          const result = response.data.result ? response.data.result[0] : []
          if (result) {
            this.warningTranslate = []
            this.isActiveBtn = true
            const workShift = this.listWorkShiftMedical ? this.listWorkShiftMedical.find(itm => itm.key === result.workShiftKey) : null
            this.messageActualTranslate = workShift ? workShift.name : ('Не определен медосмотр по ' + (result.workShiftKey ? result.workShiftKey : ''))
            if (this.isMedicEmployee && result.isStarted !== null) {
              this.setStateBtn(result.isStarted)
            } else if (!this.isMedicEmployee) {
              const factStartTime = result.factStartTime
                ? new Date(manba(new Date(result.factStartTime)).add(-1, manba.HOUR).format('YYYY-MM-DD HH:mm'))
                : null
              const factEndTime = result.factEndTime
                ? new Date(manba(new Date(result.factEndTime)).add(1, manba.HOUR).format('YYYY-MM-DD HH:mm'))
                : null
              this.setStateBtn(!!(factStartTime && !factEndTime))
            } else {
              this.setStateBtn(false)
            }
            if (this.isMedicEmployee && result.isInaction) {
              this.showBannerMedic = true
            } else {
              this.showBannerMedic = false
            }
          } else {
            const now = new Date()
            let statusRandom = false
            const txtListTranslate = []
            let actualTranslate = ''
            if (this.listWorkShiftMedical && this.listWorkShiftMedical[0]) {
              this.listWorkShiftMedical.forEach(itm => {
                txtListTranslate.push({
                  name: itm.name,
                  date: manba(new Date(itm.startTime)).format('DD.MM.YYYY'),
                  start: manba((new Date(manba(new Date(itm.startTime)).add(-1, manba.HOUR).format('YYYY-MM-DD HH:mm')))).format('HH:mm'),
                  finish: manba((new Date(manba(new Date(itm.endTime)).add(1, manba.HOUR).format('YYYY-MM-DD HH:mm')))).format('HH:mm')
                })
                statusRandom |=
                (new Date(manba(new Date(itm.startTime)).add(-1, manba.HOUR).format('YYYY-MM-DD HH:mm'))).getTime() <= now.getTime() &&
                (new Date(manba(new Date(itm.endTime)).add(1, manba.HOUR).format('YYYY-MM-DD HH:mm'))).getTime() > now.getTime()
                if (statusRandom && actualTranslate == '') {
                  actualTranslate = itm.name + ' можно начинать!'
                }
              })
            }
            this.setStateBtn(false)
            if (statusRandom && this.startBtn) {
              this.testFinishMedical(actualTranslate)
            } else {
              this.warningTranslate = statusRandom ? [] : txtListTranslate
              this.messageActualTranslate = statusRandom ? actualTranslate : ''
              this.isActiveBtn = statusRandom
            }
            this.showBannerMedic = false
          }
          return Promise.resolve(true)
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка статусов старта/финиша (Exception)',
            progress: true,
            timeout: 10000
          })

          return Promise.reject(response.message)
        }
      })
    },
    testFinishMedical: function (actualTranslate = '') {
      const urlName = '/service/delta/journal/regularMedicalSchedule/getDayMedicalExamStatus?isCurrent=false&time=' + (new Date()).getTime()
      return axiosPost({
        url: urlName,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          const result = response.data.result ? response.data.result : []
          let state = false
          let txtWarning = ''
          if (result) {
            result.forEach(item => {
              const startTime = new Date(manba(new Date(item.planStartTime)).add(-1, manba.HOUR).format('YYYY-MM-DD HH:mm'))
              const finishTime = new Date(manba(new Date(item.planEndTime)).add(1, manba.HOUR).format('YYYY-MM-DD HH:mm'))
              if (item.factEndTime && item.factStartTime) {
                if (finishTime.getTime() >= (new Date()).getTime() && (new Date()).getTime() >= startTime.getTime()) {
                  state = true
                  txtWarning = ' Время завершения: ' + manba(new Date(item.factEndTime)).format('DD.MM.YYYY HH:mm')
                }
              }
            })
            if (state) {
              this.messageActualTranslate = 'Медосмотр завершен! ' + txtWarning
              this.isActiveBtn = false
              this.startBtn = false
            } else {
              this.messageActualTranslate = actualTranslate
              this.isActiveBtn = true
              this.startBtn = true
            }
          }
          return Promise.resolve(true)
        },
        onFailure: (response) => {
          const errorMessage = response.message ? response.message : 'Ошибка получения информации по медикам (Exception старта/финиша)'
          this.$q.notify({
            type: 'negative',
            message: errorMessage,
            progress: true,
            timeout: 10000
          })

          return Promise.reject(errorMessage)
        }
      })
    },
    getRecordOnKindTrip: function (records) {
      let id = null
      let medicalExaminationKindName = null
      let warning = false
      if (records.length == 1) {
        const employee = this.medicalSchedule.find(item => records.includes(item.id))
        id = employee.id
        medicalExaminationKindName = employee.medicalExaminationKindName
      } else {
        const employeePostTrip = this.medicalSchedule.find(item => records.includes(item.id) &&
                  item.medicalExaminationKind == 'postTrip')
        if (employeePostTrip && !employeePostTrip.medicalExaminationResult) {
          id = employeePostTrip.id
          medicalExaminationKindName = employeePostTrip.medicalExaminationKindName
          warning = true
        } else {
          const employeePreTrip = this.medicalSchedule.find(item => records.includes(item.id) &&
                  item.medicalExaminationKind == 'preTrip')
          id = employeePreTrip.id
          medicalExaminationKindName = employeePreTrip.medicalExaminationKindName
        }
      }
      EventBus.$emit('set-record-on-kind-trip', id, medicalExaminationKindName, warning)
    }
  }
}

